import axios from "../utils/axios";
import { buildFilterQueryString, buildSortingParams } from "../utils/query";

export const getSectors = async ({ offset, limit, filters, sortModel } = {}) => {
  const filterQueryString = buildFilterQueryString(filters);
  const sortingParams = buildSortingParams(sortModel);
  const queryParts = [limit != null && `limit=${limit}`, offset != null && `offset=${offset}`, filterQueryString, sortingParams].filter(Boolean);
  const url = `/sectors?${queryParts.join("&")}`;
  const { data: sectors } = await axios.get(url);
  return sectors;
};

export const removeSector = async (sectorId) => {
  const { data: removedSector } = await axios.delete(`/sectors/${sectorId}`);
  return removedSector;
};

export const addSector = async (sector) => {
  const { data: addedSector } = await axios.post(`/sectors`, {
    data: sector,
  });
  return addedSector;
};

export const updateSector = async ({ id, ...sectorData }) => {
  const { data: updatedSector } = await axios.put(`/sectors/${id}`, {
    data: sectorData,
  });
  return updatedSector;
};
